import { useLayout } from '@approvalmax/ui/src/components';
import { SetupStartHardEnforcement } from 'modules/components';
import { SimplePageLayout } from 'modules/page';
import { FC, memo } from 'react';

import { useTwoFaHardEnforcementPage } from './TwoFaHardEnforcementPage.hooks';
import { messages } from './TwoFaHardEnforcementPage.messages';

export const TwoFaHardEnforcementPage: FC = memo(() => {
    useLayout({ hasHeader: false, hasDrawer: false });

    const { onWizardStart, authenticated } = useTwoFaHardEnforcementPage();

    if (!authenticated) return null;

    return (
        <SimplePageLayout documentTitle={messages.title} showMobileAppButtons={true} oldDesign>
            <SetupStartHardEnforcement onStart={onWizardStart} />
        </SimplePageLayout>
    );
});

export default TwoFaHardEnforcementPage;
